import { urlFormAlternance, urlFormBtoB, urlFormBtoCtoB } from './constants';

export const CPF_FINANCEMENT_CODE = '2771';
export const ALTERNANCE_FINANCEMENT_CODE = '2774';
export const UNCOVERED_DOMAIN_ID = -1;

export const REDIRECTION_FORM_ALTERNANCE = 'redirectFormAlternance';
export const REDIRECTION_FORM_BTOB = 'redirectFormBtoB';
export const REDIRECTION_FORM_BTOCTOB = 'redirectFormBtoCtoB';

export const REDIRECTION_URLS = {
  [REDIRECTION_FORM_ALTERNANCE]: {
    value: urlFormAlternance,
    origin: 'bitrix',
  },
  [REDIRECTION_FORM_BTOB]: {
    value: urlFormBtoB,
    origin: 'Form Site EF - Former mes collaborateurs',
  },
  [REDIRECTION_FORM_BTOCTOB]: {
    value: urlFormBtoCtoB,
    origin: 'Form Site EF - Financement entreprise',
  },
} as const;

export const isRedirectionBranch = (
  branch: string,
): branch is keyof typeof REDIRECTION_URLS => branch in REDIRECTION_URLS;

// Options for step one
export const professionalSituationOptions = [
  {
    id: '378',
    name: 'Salarié.e',
    icon: 'briefcase',
  },
  {
    id: '382',
    name: "Demandeur.se d'emploi",
    icon: 'magnifying_glass',
  },
  {
    id: '384',
    name: 'Étudiant.e',
    icon: 'graduate_hat',
  },
  {
    id: '4346',
    name: 'Entrepreneur·euse / Indépendant·e',
    icon: 'briefcase',
  },
  {
    id: '1713',
    name: 'Fonctionnaire',
    icon: 'school',
  },
  {
    id: '388',
    name: 'Autre (Précisez) : ',
    icon: 'source_other',
    condition: 'professionalSituationName',
  },
];

export const objectifOptions = [
  {
    id: '2750',
    name: 'Améliorer mes compétences professionnelles',
    icon: 'target',
  },
  {
    id: '2751',
    name: 'Me reconvertir, changer de voie',
    icon: 'finger_pointing',
  },
  {
    id: '2752',
    name: 'Obtenir une certification, un diplôme reconnu',
    icon: 'student',
  },
  {
    id: '2753',
    name: 'Trouver un emploi',
    icon: 'magnifying_glass',
  },
  {
    id: '2754',
    name: 'Former des collaborateur·rices',
    icon: 'busts_in_silhouette',
    condition: REDIRECTION_FORM_BTOB,
  },
  {
    id: '2755',
    name: 'Autre objectif professionnel',
    icon: 'ellipsis',
  },
];

export const financementOptions = [
  {
    id: CPF_FINANCEMENT_CODE,
    name: 'Mon CPF',
    icon: 'folder',
    condition: '',
  },
  {
    id: '2772',
    name: 'Mes économies',
    icon: 'credit_card',
    condition: '',
  },
  {
    id: '2773',
    name: 'Mon entreprise',
    icon: 'office_building',
    condition: REDIRECTION_FORM_BTOCTOB,
  },
  {
    id: ALTERNANCE_FINANCEMENT_CODE,
    name: 'Un contrat en alternance',
    icon: 'raising_hand',
    condition: REDIRECTION_FORM_ALTERNANCE,
  },
  {
    id: '3029',
    name: 'Autre moyen de financement (France Travail, Région, etc.)',
    icon: 'magnifying_glass',
  },
  {
    id: '2775',
    name: 'Je ne sais pas encore',
    icon: 'ellipsis',
    condition: '',
  },
];

export const formationModeOptions = [
  {
    id: '4296',
    name: 'Je souhaite de la formation en ligne',
    icon: 'digital',
  },
  {
    id: '4295',
    name: 'Je souhaite du présentiel',
    icon: 'school',
  },
  {
    id: '4297',
    name: 'Je ne sais pas encore',
    icon: 'undecided',
  },
];

// Formation concerner par "Quand souhaitez-vous débuter ?"
export const DELAI_DEBUT_BITRIX_IDS = new Set([
  2988, 3096, 3097, 3644, 3673, 3802,
]);

// Bitrix ID de Formateur de formateur
export const FORMATEUR_BITRIX_IDS = new Set([3720]);

export const delaiDebutOptions = [
  {
    id: '4349',
    name: 'Dès que possible',
    icon: 'schedule',
    color: 'inherit',
  },
  {
    id: '4350',
    name: "D'ici 1 mois",
    icon: 'looks_one',
    color: 'inherit',
  },
  {
    id: '4351',
    name: "D'ici 3 mois",
    icon: 'looks_3',
    color: 'inherit',
  },
  {
    id: '4352',
    name: 'Dans 6 mois',
    icon: 'looks_6',
    color: 'inherit',
  },
  {
    id: '4353',
    name: 'Je ne sais pas encore',
    icon: 'undecided',
  },
];

export const domaineExpertiseOptions = [
  {
    id: '4359',
    name: 'Oui (Lequel ?) : ',
    icon: 'check_circle',
    color: 'inherit',
    condition: 'expertisePrecision',
  },
  {
    id: '4360',
    name: 'Non',
    icon: 'cancel',
    color: 'inherit',
  },
];

export const transmettreCompetencesOptions = [
  {
    id: '4363',
    name: 'Oui',
    icon: 'check_circle',
    color: 'inherit',
  },
  {
    id: '4364',
    name: 'Non',
    icon: 'cancel',
    color: 'inherit',
  },
];

export const experienceEsthetiqueOptions = [
  {
    id: '4367',
    name: 'Oui',
    icon: 'check_circle',
    color: 'inherit',
  },
  {
    id: '4368',
    name: 'Non',
    icon: 'cancel',
    color: 'inherit',
  },
];

export const stageOptions = [
  {
    id: '4373',
    name: 'Oui',
    icon: 'check_circle',
    color: 'inherit',
  },
  {
    id: '4374',
    name: 'Non',
    icon: 'cancel',
    color: 'inherit',
  },
];

// Bitrix ID de Esthétique
export const ESTHETIQUE_BITRIX_IDS = new Set([2380]);

export const INTERETS_ESTHETIQUE_EXCLUSIVE = ['4409', '4410'];

export const interetsEsthetiqueOptions = [
  {
    id: '4405',
    name: 'Soins du visage',
    icon: 'spa',
    color: 'primary',
  },
  {
    id: '4406',
    name: 'Maquillage',
    icon: 'brush',
    color: 'orange',
  },
  {
    id: '4407',
    name: 'Ongles',
    icon: 'back_hand',
    color: 'yellow',
  },
  {
    id: '4408',
    name: 'Épilation',
    icon: 'content_cut',
    color: 'mediumGreen',
  },
  {
    id: '4409',
    name: 'Tout le programme',
    icon: 'checklist',
    color: 'success',
  },
  {
    id: '4410',
    name: 'Je ne sais pas encore',
    icon: 'undecided',
  },
];

// Bitrix ID de Petite Enfance
export const PETITE_ENFANCE_BITRIX_IDS = new Set([3032]);

export const formationPetiteEnfanceOptions = [
  {
    id: '4411',
    name: 'CAP Petite Enfance',
    icon: 'child_care',
    color: 'primary',
  },
  {
    id: '4412',
    name: 'CAP Petite Enfance + concours ATSEM',
    icon: 'group',
    color: 'orange',
  },
  {
    id: '4413',
    name: 'Concours ATSEM seul',
    icon: 'badge',
    color: 'yellow',
  },
  {
    id: '4414',
    name: 'Auxiliaire de puériculture',
    icon: 'stroller',
    color: 'mediumGreen',
  },
  {
    id: '4415',
    name: 'Autre',
    icon: 'ellipsis',
  },
];

// Bitrix ID deCréation d'entreprise
export const CREA_ENTREPRISE_BITRIX_IDS = new Set([3802]);

export const ideeProjetOptions = [
  {
    id: '4371',
    name: 'Oui (Lequel ?) : ',
    icon: 'check_circle',
    color: 'inherit',
    condition: 'projetPrecision',
  },
  {
    id: '4372',
    name: 'Non',
    icon: 'cancel',
    color: 'inherit',
  },
];

export const typeStructureOptions = [
  {
    id: '4375',
    name: 'SAS/SASU',
    icon: 'groups',
    color: 'primary',
  },
  {
    id: '4376',
    name: 'SARL/EURL',
    icon: 'corporate_fare',
    color: 'orange',
  },
  {
    id: '4377',
    name: 'Auto-entrepreneur',
    icon: 'storefront',
    color: 'yellow',
  },
  {
    id: '4378',
    name: 'Entreprise individuelle',
    icon: 'person',
    color: 'mediumGreen',
  },
  {
    id: '4379',
    name: 'Je ne sais pas',
    icon: 'undecided',
  },
];

export const secteurActiviteOptions = [
  {
    id: '4380',
    name: 'Commerce',
    icon: 'store',
    color: 'primary',
  },
  {
    id: '4381',
    name: 'Services',
    icon: 'handshake',
    color: 'orange',
  },
  {
    id: '4382',
    name: 'Artisanat',
    icon: 'handyman',
    color: 'yellow',
  },
  {
    id: '4383',
    name: 'Numérique',
    icon: 'devices',
    color: 'mediumGreen',
  },
  {
    id: '4384',
    name: 'Événementiel',
    icon: 'celebration',
    color: 'success',
  },
  {
    id: '4385',
    name: 'Santé',
    icon: 'medical_services',
    color: 'primary',
  },
  {
    id: '4386',
    name: 'Autre',
    icon: 'ellipsis',
  },
  {
    id: '4387',
    name: 'Je ne sais pas encore',
    icon: 'undecided',
  },
];

// Bitrix ID de TP Développeur web
export const TP_DEV_BITRIX_IDS = new Set([4310]);

export const equipementInfoOptions = [
  {
    id: '4416',
    name: 'Oui',
    icon: 'check_circle',
    color: 'inherit',
  },
  {
    id: '4417',
    name: 'Non',
    icon: 'cancel',
    color: 'inherit',
  },
  {
    id: '4418',
    name: 'Je ne sais pas',
    icon: 'undecided',
  },
];

export const niveauAnglaisOptions = [
  {
    id: '4419',
    name: 'Notions de base',
    silencedText: '(Je comprends quelques mots / expressions simples)',
    icon: 'abc',
    color: 'primary',
  },
  {
    id: '4420',
    name: 'Professionnel limité',
    silencedText: "(Je peux échanger par email, mais difficile à l'oral)",
    icon: 'edit_note',
    color: 'orange',
  },
  {
    id: '4421',
    name: 'Professionnel courant',
    silencedText: '(Je gère des réunions et des présentations sans problème)',
    icon: 'record_voice_over',
    color: 'yellow',
  },
  {
    id: '4422',
    name: 'Bilingue / Langue maternelle',
    icon: 'language',
    color: 'mediumGreen',
  },
];

export const etudesOptions = [
  {
    id: '2743',
    name: 'Brevet',
    icon: 'yellow_notebook',
  },
  {
    id: '2744',
    name: 'CAP, BEP ou équivalent',
    icon: 'red_notebook',
  },
  {
    id: '2745',
    name: 'Bac ou équivalent',
    icon: 'green_notebook',
  },
  {
    id: '2746',
    name: 'Bac +2',
    icon: 'blue_notebook',
  },
  {
    id: '2747',
    name: 'Bac +3',
    icon: 'orange_notebook',
  },
  {
    id: '2788',
    name: 'Bac +4',
    icon: 'yellow_notebook_alt',
  },
  {
    id: '2748',
    name: 'Bac +5 et plus',
    icon: 'stack_of_books',
  },
  {
    id: '2749',
    name: 'Aucun',
    icon: 'ellipsis',
  },
];

export const genderOptions = [
  {
    id: '2742',
    name: 'Madame',
  },
  {
    id: '2741',
    name: 'Monsieur',
  },
];

const sourcesOptionsRaw = [
  {
    id: '4172',
    name: 'Bouche à Oreille',
    silencedText: "(Recommandation d'un proche)",
    icon: 'source_bouche_oreille',
  },
  {
    id: '4173',
    name: 'Moteur de recherche',
    silencedText: '(Google, bing ...)',
    icon: 'source_moteur',
  },
  {
    id: '4174',
    name: 'Réseaux sociaux',
    silencedText: '(Instagram, Facebook, Tiktok ...)',
    icon: 'source_networks',
  },
  {
    id: '4175',
    name: "Site d'offre d'emploi",
    silencedText: '(Indeed, Hellowork ...)',
    icon: 'source_site',
  },
  {
    id: '4176',
    name: 'Outils IA',
    silencedText: '(ChatGPT, Perplixity ...)',
    icon: 'source_ia',
  },
  {
    id: '4177',
    name: 'Articles de presse',
    icon: 'source_press',
  },
  {
    id: '4178',
    name: 'Comparateur de formations',
    icon: 'source_comparateur',
  },
  {
    id: '4181',
    name: 'MonCompteFormation',
    icon: 'school',
  },
  {
    id: '4182',
    name: "Organisme d'orientation (France Travail, Pôle emploi, Mission locale, etc.)",
    icon: 'boussole',
  },
];

const getRandomizedSourceOptions = () => {
  const newArray = [...sourcesOptionsRaw];
  for (let i = newArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
  }
  return [
    ...newArray,
    {
      id: '4179',
      name: 'Je ne sais pas',
      icon: 'source_dont_know',
    },
    {
      id: '4180',
      name: 'Autres (Précisez) : ',
      icon: 'source_other',
      condition: 'sourceName',
    },
  ];
};

export const sourcesOptions = getRandomizedSourceOptions();

// seuls ces champs seront tracké dans GTM
export const correspondanceBitrixToGtm = {
  etudes: etudesOptions,
  objectif: objectifOptions,
  financement: financementOptions,
  situationPro: professionalSituationOptions,
  formationMode: formationModeOptions,
};
